import React, { useEffect, useRef, useState } from 'react';
import {
  CLASSIFICATION_OPTIONS,
  VERIFICATION_OPTIONS,
} from '../lib/filters';

export function filtersNarrowed(filters) {
  const v = filters?.verifications || [];
  const c = filters?.classifications || [];
  return (
    v.length !== VERIFICATION_OPTIONS.length ||
    c.length !== CLASSIFICATION_OPTIONS.length
  );
}

function FilterIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-6.463a2.25 2.25 0 00-.659-1.591L2.66 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function CheckList({ label, options, selected, onChange }) {
  const allSelected =
    options.length > 0 && options.every((o) => selected.includes(o.id));

  const toggle = (id) => {
    onChange(
      selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]
    );
  };

  return (
    <div>
      <div className="px-3 py-1.5 text-[12px] font-medium text-ink-muted">{label}</div>
      <label className="flex items-center gap-2 px-3 py-1.5 text-[12px] hover:bg-wash cursor-pointer">
        <input
          type="checkbox"
          checked={allSelected}
          onChange={(e) =>
            onChange(e.target.checked ? options.map((o) => o.id) : [])
          }
          className="rounded border-paper-strong"
        />
        <span>All</span>
      </label>
      {options.map((opt) => (
        <label
          key={opt.id}
          className="flex items-center gap-2 px-3 py-1.5 text-[12px] hover:bg-wash cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selected.includes(opt.id)}
            onChange={() => toggle(opt.id)}
            className="rounded border-paper-strong"
          />
          <span>{opt.id === opt.label ? opt.label : opt.id}</span>
        </label>
      ))}
    </div>
  );
}

function ContactFilters({ filters, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const active = filtersNarrowed(filters);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const verifications = filters?.verifications || [];
  const classifications = filters?.classifications || [];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 text-[12px] rounded-[4px] px-1.5 py-0.5 hover:bg-wash ${
          active ? 'text-ink' : 'text-ink-muted hover:text-ink'
        }`}
        aria-label="Filter contacts"
        aria-expanded={open}
        title="Filter by status and type"
      >
        <FilterIcon className="w-3.5 h-3.5" />
        Filter
        {active ? (
          <span className="text-ink-faint tabular-nums">
            {verifications.length + classifications.length}
          </span>
        ) : null}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1.5 z-50 w-64 max-h-[70vh] overflow-y-auto bg-white border border-paper-line rounded-[6px] shadow-popover py-1">
          <CheckList
            label="Status"
            options={VERIFICATION_OPTIONS}
            selected={verifications}
            onChange={(next) => onChange({ ...filters, verifications: next })}
          />
          <div className="h-px bg-paper-line my-1" />
          <CheckList
            label="Type"
            options={CLASSIFICATION_OPTIONS}
            selected={classifications}
            onChange={(next) => onChange({ ...filters, classifications: next })}
          />
          {active ? (
            <button
              type="button"
              onClick={() =>
                onChange({
                  verifications: VERIFICATION_OPTIONS.map((o) => o.id),
                  classifications: CLASSIFICATION_OPTIONS.map((o) => o.id),
                })
              }
              className="w-full text-left px-3 py-1.5 text-[12px] text-ink-muted hover:text-ink hover:bg-wash border-t border-paper-line"
            >
              Reset
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default ContactFilters;
